module.exports = new __parcel__URL__("oco2-mip-co2budget-yeargrid-v1--cover.a675fc71.jpg").toString();